import { TimeBudgettedTask } from './time-budgetted-task';
import { TASK_TYPES } from './task';

export class OtherTask extends TimeBudgettedTask {
  title?: string;
  description?: string;

  constructor() {
    super();
    this.type = TASK_TYPES.OTHER_TASK;
  }
}
